import { config } from '@js/index';
import { enablePointerEvents, disablePointerEvents } from '@utils/pointer-events-control';
import GameButton from '@components/GameButton';

export default class StartScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'StartScene',
    });
  }

  preload() {}

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    const gameState = this.game.__gameState;

    disablePointerEvents();

    this.add.sprite(0, 0, 'bg-start-scene').setOrigin(0);

    // bg-start-scene has the city art + "City Builder" title; the Play button is overlaid here.
    this.playButton = new GameButton(this, config.width / 2, 620, 'playButton', {
      hoverScale: 1.08,
      pressScale: 0.92,
      tweenDuration: 120,
    }).onClick(() => {
      this.playButton.disableInteractive();
      enablePointerEvents();

      this.scene.stop('StartScene');
      this.scene.start('GameScene', gameState);
    });
    this.playButton.setDepth(5);
  }

  update() {}
}
